import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import ReservationModal from '../components/ReservationModal';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [headerHidden, setHeaderHidden] = useState(false);
  const [mainNavTop, setMainNavTop] = useState(false);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      // Handle header visibility on scroll
      if (window.scrollY > 100) {
        setHeaderHidden(true);
        setMainNavTop(true);
      } else {
        setHeaderHidden(false);
        setMainNavTop(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleOpenBookingModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setBookingModalOpen(true);
  };

  const handleCloseBookingModal = () => {
    setBookingModalOpen(false);
  };

  return (
    <>
      <header>
        <div className={`header-top ${headerHidden ? 'header-top-hidden' : ''}`}>
          <div className="container">
            <div className="contact-info">
              <span><i className="fas fa-phone"></i> (555) 123-4567</span>
              <span><i className="fas fa-envelope"></i> info@fallenleaflodge.com</span>
            </div>
            <div className="weather-widget">
              <div className="weather-info">
                <div className="weather-item">
                  <i className="fas fa-temperature-high"></i>
                  <span id="temperature">--°F</span>
                </div>
                <div className="weather-item">
                  <i className="fas fa-water"></i>
                  <span id="water-temp">--°F</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <nav className={`main-nav ${mainNavTop ? 'main-nav-top' : ''}`}>
          <div className="container">
            <div className="logo">
              <Link to="/">
                <img src="/images/logo.png" alt="Fallen Leaf Lodge Logo" />
              </Link>
            </div>
            <ul className="nav-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/marina">Marina</Link></li>
              <li><Link to="/cafe">Cafe</Link></li>
              <li><Link to="/store">Store</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#" onClick={handleOpenBookingModal} className="btn btn-small">Book Now</a></li>
            </ul>
            <div className="mobile-menu-toggle">
              <i className="fas fa-bars"></i>
            </div>
          </div>
        </nav>
      </header>
      
      <main>
        {children}
      </main>
      
      <footer>
        <div className="footer-main">
          <div className="container">
            <div className="footer-grid">
              <div className="footer-column">
                <h4>About Us</h4>
                <p>Fallen Leaf Lodge has been serving visitors since 1908, offering marina services, dining, and a general store for all your lake adventure needs.</p>
              </div>
              
              <div className="footer-column">
                <h4>Quick Links</h4>
                <ul className="footer-links">
                  <li><Link to="/marina">Marina Services</Link></li>
                  <li><Link to="/cafe">Lakeside Cafe</Link></li>
                  <li><Link to="/store">General Store</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                </ul>
              </div>
              
              <div className="footer-column">
                <h4>Contact Info</h4>
                <ul className="contact-info">
                  <li><i className="fas fa-map-marker-alt"></i>1 Fallen Leaf Road, South Lake Tahoe, CA</li>
                  <li><i className="fas fa-phone"></i>(555) 123-4567</li>
                  <li><i className="fas fa-envelope"></i>info@fallenleaflodge.com</li>
                </ul>
              </div>
              
              <div className="footer-column">
                <h4>Weather</h4>
                <div className="weather-widget">
                  <div id="weather-data">
                    <p><i className="fas fa-temperature-high"></i> Air Temp: <span id="footer-temperature">--°F</span></p>
                    <p><i className="fas fa-water"></i> Water Temp: <span id="footer-water-temp">--°F</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="container">
            <p>&copy; {new Date().getFullYear()} Fallen Leaf Lodge. All Rights Reserved.</p>
            <div className="social-links">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
            </div>
          </div>
        </div>
      </footer>

      {/* Booking Modal */}
      <ReservationModal open={bookingModalOpen} onClose={handleCloseBookingModal} />
    </>
  );
};

export default MainLayout; 